// IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): ДВИЖОК СНИМКА содержимого виджета (без шапки) — html2canvas 1.4.1 (ленивый чанк
// html2canvas, тот же, что у testRecorder.js) с ОТСЕЧЁННЫМ клоном: копируются только предки области и её поддерево (замер A1: отчёт 16–22 с → 3 с).
// Дизайн — handoff-files/widget-previews-2026-09-27/DESIGN.md (лейн ie-webscm7), раздел 5. Что снимается: #WIDGET<id> > .widget-content;
// длинная сторона ≤ 480 (fe.data.widgetPreviewLong) + миниатюра ≤ 240 (fe.data.widgetPreviewThumb), WebP 0.8, если браузер не кодирует WebP — JPEG.
// В клоне: размер закреплён (без этого 813 → 850 px), маски ie-ico-* спрятаны (иначе залитые квадраты), анимации сняты, классы чужого выделения /
// наведения сняты, всплывающее и служебное (островки кнопок, легенды, подсказки, формы) не копируется. Граф WebGL (sigma): refresh + drawImage всех
// холстов в одной задаче → картинка вместо WebGL-холстов в клоне (без этого слои рёбер и узлов пустые). Отдельно от состояния и транспорта
// (utils/widgetPreviews.js): здесь только DOM и холсты.

// IE 2026 09 30 / ODOO-343462 (Игорь: миниатюра графика пустая): '.chart-hover-values' здесь НЕ должно быть — это класс-состояние на хосте графика при наведении (снимок выкидывал весь график)
export const PREVIEW_SKIP_SEL = [
    '.corner-island', '[class*="attr-geomap-island"]', '.ant-flow-player', '.ant-flow-legend-btn', '.ant-flow-tip', '.attr-geomap-panel', '.attr-graph-mappanel',
    '.attr-treemap-panel', '.chart-legend-panel', '.chart-hover-badge', '.chart-hover-tag', '.chart-hover-xlabel', '.chart-hover-axis-label',
    '.wj-chart-linemarker', '.attr-geomap-badge', '.attr-geomap-llabel', '.attr-graph-badge', '.bubble-hover-ring', '.bubble-rect-sel', '.wj-marquee',
    '.cell-dropdown-toggle', '.infl-formula', '.clip-overlay', '.wj-tooltip', '.p-tooltip', '.dropdown', '.menu-panel', '.widget-topleft-form',
].join(', ')
export const PREVIEW_STRIP_CLASSES = ['wj-state-selected', 'wj-state-multi-selected', 'wj-row-hover', 'at-active', 'cell-same-value', 'metric-hit-cell', 'metric-hit-cur-cell',
    'cell-infl-plus', 'cell-infl-minus', 'cell-infl-plus-unc', 'cell-infl-minus-unc', 'cell-infl-base', 'chart-hover-dim', 'chart-hover-soft']
export const PREVIEW_EMPTY_SEL = '.chart-empty-msg, .attr-geomap-empty, .bubble-chart-empty, .attr-gantt-empty, .an-empty, .ant-flow-empty'
export const PREVIEW_MIN_W = 120
export const PREVIEW_MIN_H = 80
// маски значков — прячутся (html2canvas не умеет mask-image); анимации / переходы / каретка — выключены (снимок — один кадр)
const CLONE_CSS = '[class*="ie-ico-"]::before, [class*="ie-ico-"]::after { -webkit-mask-image: none !important; mask-image: none !important; background: transparent !important; }\n'
    + '*, *::before, *::after { animation: none !important; transition: none !important; caret-color: transparent !important; }'
const KEEP_TAGS = new Set(['STYLE', 'LINK', 'META', 'TITLE'])

const visible = (n) => { try { return !!n && n.getClientRects().length > 0 } catch (e) { return false } }
const firstVisible = (el, sel) => { for (const n of el.querySelectorAll(sel)) if (visible(n)) return n; return null }

export function previewRoot(W) {
    const root = (W && W.id !== undefined && W.id !== null) ? document.getElementById('WIDGET' + W.id) : null
    const el = root ? root.querySelector(':scope > .widget-content') : null
    return { root, el }
}

// готовность к снимку: why — код причины отказа (widgetPreviews.js переводит в текст); opts.allowMax — развёрнутый Alt F разрешён (команда), автосъёмке — нет
export function previewReady(W, opts = {}) {
    if (!W) return { ok: false, why: 'no-widget' }
    if (W.close || W._softClosed || W._hiddenOpen) return { ok: false, why: 'closed' }
    if (W.loading || W.firstBackendCheck) return { ok: false, why: 'loading' }
    const { root, el } = previewRoot(W)
    if (!root || !el) return { ok: false, why: 'no-dom' }
    const cl = root.classList
    if (cl.contains('widget-hidden')) return { ok: false, why: 'hidden' }
    if (cl.contains('widget-reveal-pending') || cl.contains('widget-first-loading')) return { ok: false, why: 'loading' }
    if (cl.contains('widget-mobile-max') && !opts.allowMax) return { ok: false, why: 'maximized' }
    if (!visible(el)) return { ok: false, why: 'hidden' }
    const r = el.getBoundingClientRect()
    if (r.width < PREVIEW_MIN_W || r.height < PREVIEW_MIN_H) return { ok: false, why: 'too-small' }
    return { ok: true, why: '', root, el }
}

// вид виджета по ВИДИМОЙ части (скрытые вкладки не в счёт): graph | map | antflow | gantt | bubbles | treemap | chart | report | list | other
export function previewKindOf(W, el) {
    if (!el) return 'other'
    if (firstVisible(el, '#graph-container')) return 'graph'
    if (firstVisible(el, '.attr-geo-map, [class*="attr-geomap"]')) return 'map'
    if (firstVisible(el, '.ant-flow')) return 'antflow'
    if (firstVisible(el, '.attr-gantt-moves, .attr-gantt')) return 'gantt'
    if (firstVisible(el, '.attr-bubble-chart')) return 'bubbles'
    if (firstVisible(el, '.attr-tree-map')) return 'treemap'
    if (firstVisible(el, '.attr-chart')) return 'chart'
    if (firstVisible(el, '.wj-flexgrid')) return String((W && W.record && W.record.segment) || '').startsWith('WIDGET-REPORT') ? 'report' : 'list'
    return 'other'
}

// пусто ли содержимое (для автосъёмки): видимая заглушка «нет данных», граф без узлов, у видимых гридов нет ни одной ячейки данных
export function previewIsEmpty(W, el) {
    if (!el) return true
    if (firstVisible(el, PREVIEW_EMPTY_SEL)) return true
    const gc = firstVisible(el, '#graph-container')
    if (gc) { const g = gc.__vueGraph && gc.__vueGraph.graph; return !g || !(g.order > 0) }
    const kind = previewKindOf(W, el)
    if (kind === 'report' || kind === 'list') {
        const grids = [...el.querySelectorAll('.wj-flexgrid')].filter(visible)
        if (grids.length && grids.every(g => !g.querySelector('[wj-part="cells"] .wj-cell'))) return true
    }
    return false
}

export function parseColor(css) {
    const m = String(css || '').match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+%?))?\s*\)/)
    if (m) { let a = m[4] === undefined ? 1 : parseFloat(m[4]); if (String(m[4] || '').endsWith('%')) a /= 100; return { r: +m[1], g: +m[2], b: +m[3], a } }
    const h = String(css || '').trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
    if (h) { const s = h[1].length === 3 ? h[1].split('').map(c => c + c).join('') : h[1]; return { r: parseInt(s.slice(0, 2), 16), g: parseInt(s.slice(2, 4), 16), b: parseInt(s.slice(4, 6), 16), a: 1 } }
    return null
}
// фон области: первый непрозрачный фон вверх по предкам, иначе белый
export function previewBgOf(el) {
    for (let n = el; n && n.nodeType === 1; n = n.parentElement) {
        try { const c = parseColor(getComputedStyle(n).backgroundColor); if (c && c.a > 0.5) return `rgb(${Math.round(c.r)}, ${Math.round(c.g)}, ${Math.round(c.b)})` } catch (e) { /* узел исчез */ }
    }
    return 'rgb(255, 255, 255)'
}

// граф WebGL (sigma): все холсты контейнера в 2D-холст полного размера В ОДНОЙ задаче с refresh (буфер WebGL без preserveDrawingBuffer к следующему
// кадру пуст); холсты метятся data-pv-snap — в клоне первый заменяется картинкой, остальные удаляются (путь A1: 1,27 с на графе 89 узлов)
export function previewGraphComposite(el) {
    const host = el && firstVisible(el, '#graph-container')
    const comp = host && host.__vueGraph
    const sig = comp && comp.sigma
    if (!sig || typeof sig.getContainer !== 'function') return null
    const cont = sig.getContainer()
    const r = cont.getBoundingClientRect()
    if (!r.width || !r.height) return null
    const full = document.createElement('canvas')
    full.width = Math.round(r.width); full.height = Math.round(r.height)
    const g = full.getContext('2d')
    try { sig.refresh() } catch (e) { /* без перерисовки — что есть */ }
    const canv = [...cont.querySelectorAll('canvas')]
    for (const cv of canv) {
        const cr = cv.getBoundingClientRect()
        if (!cr.width || !cr.height) continue
        try { g.drawImage(cv, cr.left - r.left, cr.top - r.top, cr.width, cr.height) } catch (e) { /* холст недоступен */ }
    }
    let url = ''
    try { url = full.toDataURL('image/png') } catch (e) { return null }
    canv.forEach((c, i) => c.setAttribute('data-pv-snap', String(i)))
    return { url, canvases: canv, w: r.width, h: r.height }
}

export function previewScaleCanvas(src, long) {
    const w = src.width, h = src.height, m = Math.max(w, h)
    if (!long || m <= long) return src
    const k = long / m
    if (Math.min(w, h) * k < 8) return src   // миниатюра не уже 8 px — иначе без миниатюры (панель возьмёт картинку)
    const out = document.createElement('canvas')
    out.width = Math.max(1, Math.round(w * k)); out.height = Math.max(1, Math.round(h * k))
    const g = out.getContext('2d')
    g.imageSmoothingEnabled = true
    try { g.imageSmoothingQuality = 'high' } catch (e) { /* старый браузер */ }
    g.drawImage(src, 0, 0, out.width, out.height)
    return out
}

// кодек: WebP; браузер, который WebP не кодирует (Safari отдаёт PNG), — JPEG 0.82
export async function previewEncode(canvas, quality = 0.8) {
    const toBlob = (type, q) => new Promise((res) => { try { canvas.toBlob((b) => res(b), type, q) } catch (e) { res(null) } })
    let b = await toBlob('image/webp', quality)
    if (b && b.type === 'image/webp') return { blob: b, mime: 'image/webp' }
    b = await toBlob('image/jpeg', 0.82)
    if (b && b.type === 'image/jpeg') return { blob: b, mime: 'image/jpeg' }
    throw new Error('the browser cannot encode the picture')
}

// пустой снимок: ~2 000 точек холста, больше 98 % совпадает с фоном (±6 по каналу) — ловит пустой WebGL и сбои отрисовки
export function previewIsBlank(canvas, bg, share = 0.98) {
    try {
        const w = canvas.width, h = canvas.height, N = w * h
        if (!N) return true
        const d = canvas.getContext('2d').getImageData(0, 0, w, h).data
        const c = bg || { r: 255, g: 255, b: 255 }
        const step = Math.max(1, Math.floor(N / 2000))
        let same = 0, n = 0
        for (let i = 0; i < N; i += step) {
            const o = i * 4; n++
            if (Math.abs(d[o] - c.r) <= 6 && Math.abs(d[o + 1] - c.g) <= 6 && Math.abs(d[o + 2] - c.b) <= 6) same++
        }
        return n > 0 && same / n > share
    } catch (e) { return false }
}

// IE 2026 09 30 / ODOO-343462 (Игорь: миниатюра графика пустая): html2canvas 1.4.1 не разбирает color(srgb …) (так Chrome отдаёт вычисленный color-mix(), например рамку капсулы «начало плана»: снимок отчёта падал с
// «unsupported color function color»). Цвета вида color(…) в клоне переводятся в rgb(a) — холст 1x1 понимает любое пространство CSS.
const CFIX_PROPS = [['color', 'color'], ['backgroundColor', 'background-color'], ['borderTopColor', 'border-top-color'], ['borderRightColor', 'border-right-color'],
    ['borderBottomColor', 'border-bottom-color'], ['borderLeftColor', 'border-left-color'], ['outlineColor', 'outline-color'], ['textDecorationColor', 'text-decoration-color'],
    ['boxShadow', 'box-shadow'], ['textShadow', 'text-shadow'], ['backgroundImage', 'background-image']]
const CFIX_RE = /(^|[^\w-])color\((?:[^()]|\([^()]*\))*\)/g
let _cfx = null
function colorFnToRgb(m) {
    try {
        if (!_cfx) { const cv = document.createElement('canvas'); cv.width = 1; cv.height = 1; _cfx = cv.getContext('2d', { willReadFrequently: true }) }
        _cfx.clearRect(0, 0, 1, 1); _cfx.fillStyle = '#000'; _cfx.fillStyle = m; _cfx.fillRect(0, 0, 1, 1)
        const d = _cfx.getImageData(0, 0, 1, 1).data
        return d[3] === 255 ? `rgb(${d[0]}, ${d[1]}, ${d[2]})` : `rgba(${d[0]}, ${d[1]}, ${d[2]}, ${+(d[3] / 255).toFixed(3)})`
    } catch (e) { return 'transparent' }
}
export function previewFixColors(doc, root) {
    const t0 = performance.now(), view = doc && doc.defaultView
    let fixed = 0, nodes = 0
    if (view && root) {
        for (const n of [root, ...root.querySelectorAll('*')]) {
            if (!n.style) continue
            nodes++
            let cs = null
            try { cs = view.getComputedStyle(n) } catch (e) { continue }
            for (const [k, css] of CFIX_PROPS) {
                const v = cs[k]
                if (v && v.indexOf('color(') >= 0) { n.style.setProperty(css, v.replace(CFIX_RE, (mm, pre) => pre + colorFnToRgb(mm.slice(pre.length))), 'important'); fixed++ }
            }
        }
    }
    try { window.__previewColorFix = { fixed, nodes, ms: Math.round(performance.now() - t0), at: Date.now() } } catch (e) { /* без счётчика */ }
    return fixed
}

let _h2c = null
async function html2canvasLib() {
    if (!_h2c) { const mod = await import(/* webpackChunkName: "html2canvas" */ 'html2canvas'); _h2c = mod.default || mod }
    return _h2c
}

// снимок: → { ok, why?, blob, mime, w, h, tblob, tmime, tw, th, src_w, src_h, ms, lt, hasLt, nodes, pruned, blank, kind, bytes, tbytes }
// opts: mode ('manual' | 'page' | 'auto'), long, thumb, quality, pruneHidden (fe.ux.widgetPreviewPruneHidden)
export async function previewCapture(W, opts = {}) {
    const t0 = performance.now()
    const rd = previewReady(W, { allowMax: opts.mode !== 'auto' })
    if (!rd.ok) return { ok: false, why: rd.why }
    const { root, el } = rd
    const R = el.getBoundingClientRect()
    const long = +opts.long || 480, thumbLong = +opts.thumb || 240, q = +opts.quality || 0.8
    let scale = Math.min(1, long / Math.max(R.width, R.height))
    const minSide = Math.min(R.width, R.height)
    if (minSide * scale < 16) scale = Math.min(1, 16 / Math.max(1, minSide))   // короткая сторона картинки не меньше 16 px (контракт бэка)
    const bg = previewBgOf(el)
    const kind = previewKindOf(W, el)
    // Float: у содержимого сверху отступ под островки шапки — полоса срезается с готового холста (размеры клона не трогаются)
    let padTop = 0
    if (root.classList.contains('widget-float-pad')) { try { padTop = parseFloat(getComputedStyle(el).paddingTop) || 0 } catch (e) { padTop = 0 } }
    const lts = []
    let po = null
    try { po = new PerformanceObserver((l) => { for (const e of l.getEntries()) lts.push(e.duration) }); po.observe({ entryTypes: ['longtask'] }) } catch (e) { po = null }
    const prune = opts.pruneHidden !== false
    let nodes = 0, pruned = 0, comp = null, canvas = null, err = null
    const inPath = (n) => n === el || (n.contains && n.contains(el)) || el.contains(n) || !!(n.closest && n.closest('head'))
    const ignore = (n) => {
        if (!n || n.nodeType !== 1) return false
        if (!inPath(n)) return true                       // (а) отсечение клона: только путь к области и её поддерево
        if (n === el || !el.contains(n)) return false      // предки области и head (стили)
        // IE 2026 09 30 / ODOO-343462 (Игорь: миниатюра графика пустая): хост Wijmo-контрола (график, грид) — не всплывающее, даже с классом-состоянием из списка
        if (n.matches && n.matches(PREVIEW_SKIP_SEL) && !(n.classList && n.classList.contains('wj-control'))) return true   // (б) всплывающее и служебное
        if (prune && n instanceof HTMLElement && !KEEP_TAGS.has(n.tagName) && n.getClientRects().length === 0) {   // (в) скрытые поддеревья (вкладки, display:none)
            let d = ''
            try { d = getComputedStyle(n).display } catch (e) { d = '' }
            if (d !== 'contents') { pruned++; return true }
        }
        nodes++
        return false
    }
    try {
        const html2canvas = await html2canvasLib()
        if (kind === 'graph') comp = previewGraphComposite(el)
        try { document.body.classList.add('preview-capturing') } catch (e) { /* без body */ }
        canvas = await html2canvas(el, {
            scale, backgroundColor: bg, logging: false, useCORS: true, imageTimeout: 4000, ignoreElements: ignore,
            onclone: (doc, c) => {
                if (c && c.style) { c.style.width = R.width + 'px'; c.style.height = R.height + 'px'; c.style.flex = 'none'; c.style.boxSizing = 'border-box'; c.style.maxHeight = 'none' }
                try { const st = doc.createElement('style'); st.textContent = CLONE_CSS; (doc.head || doc.documentElement).appendChild(st) } catch (e) { /* без стиля */ }
                // html2canvas при клонировании превращает ::before / ::after в настоящие элементы html2canvaspseudoelement со стилями ОРИГИНАЛА (фон цветом
                // текста + маска, которую он не рисует) — стиль клона до них не доходит; значки-маски прячутся здесь (место в строке остаётся)
                if (c) for (const x of c.querySelectorAll('[class*="ie-ico-"] > html2canvaspseudoelement')) { x.style.setProperty('background', 'transparent', 'important'); x.style.setProperty('visibility', 'hidden', 'important') }
                if (c) { try { previewFixColors(doc, c) } catch (e) { /* без правки цветов */ } }   // IE 2026 09 30 / ODOO-343462 (Игорь: миниатюра графика пустая)
                if (c) for (const cls of PREVIEW_STRIP_CLASSES) for (const x of c.querySelectorAll('.' + cls)) x.classList.remove(cls)
                if (comp && c) {
                    for (const cv of c.querySelectorAll('canvas[data-pv-snap]')) {
                        if (cv.getAttribute('data-pv-snap') === '0') {
                            const img = doc.createElement('img')
                            img.src = comp.url
                            img.style.cssText = `position:absolute;left:0;top:0;width:${comp.w}px;height:${comp.h}px`
                            cv.replaceWith(img)
                        } else cv.remove()
                    }
                }
            },
        })
    } catch (e) {
        err = e
    } finally {
        try { document.body.classList.remove('preview-capturing') } catch (e) { /* без body */ }
        if (comp) comp.canvases.forEach(c => { try { c.removeAttribute('data-pv-snap') } catch (e) { /* холст исчез */ } })
    }
    const ms = performance.now() - t0
    await new Promise(r => setTimeout(r, 30))
    try { if (po) po.disconnect() } catch (e) { /* уже */ }
    const lt = Math.round(Math.max(0, ...lts))
    if (err || !canvas) return { ok: false, why: 'capture-failed', error: String((err && (err.message || err)) || 'no canvas').slice(0, 200), ms: Math.round(ms), lt, kind }
    if (padTop > 0) {
        const cut = Math.round(padTop * scale)
        if (cut > 0 && cut < canvas.height - 16) {
            const c2 = document.createElement('canvas')
            c2.width = canvas.width; c2.height = canvas.height - cut
            c2.getContext('2d').drawImage(canvas, 0, -cut)
            canvas = c2
        }
    }
    const blank = previewIsBlank(canvas, parseColor(bg))
    const img = await previewEncode(canvas, q)
    const tcan = previewScaleCanvas(canvas, thumbLong)
    const th = tcan === canvas ? img : await previewEncode(tcan, q)
    return { ok: true, blob: img.blob, mime: img.mime, w: canvas.width, h: canvas.height, tblob: th.blob, tmime: th.mime, tw: tcan.width, th: tcan.height,
        src_w: Math.max(1, Math.round(R.width)), src_h: Math.max(1, Math.round(R.height)), ms: Math.round(ms), lt, hasLt: !!po, nodes, pruned, blank, kind,
        bytes: img.blob.size, tbytes: th.blob.size, thumbSame: tcan === canvas, padTop: Math.round(padTop) }
}

export default { previewCapture, previewReady, previewIsEmpty, previewKindOf, previewGraphComposite, previewEncode, previewIsBlank, previewRoot, previewBgOf,
    PREVIEW_SKIP_SEL, PREVIEW_STRIP_CLASSES, PREVIEW_EMPTY_SEL }
